<style lang="scss" scoped>
</style>
<template lang="pug">
</template>
<script>
import gql from "graphql-tag";

export default {
	methods: {
		async getUserOrg() {
			return  await this.$apollo.query({
				query: gql`
					{
						User {
							organisation_id
						}
					}
				`,
				fetchPolicy: "network-only"
			});
		}
	},
	apollo: {
		region: {
			query: gql`
				{
					Region {
						region_code
					}
				}
			`,
			update: r => {
				localStorage.setItem("graphql-region", r.Region.region_code);
			},
			async result() {
				try {
					const userOrg = await this.getUserOrg();
				
					if (userOrg.data.User.organisation_id) {
						this.$router.push({ name: "organisation.schools" });
					} else {
						this.$router.push({ name: "directory" });
					}
				} catch (e) {
					this.$router.push({ name: "directory" });
				}
			}
		}
	}
};
</script>